export default __webpack_public_path__ + "static/media/saga_background@3x.bf393a91.png";